import { useEffect, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { api, money } from '../api'
import type { Order } from '../types'

export function Confirmation() {
  const { id = '' } = useParams()
  const loc = useLocation()
  const [order, setOrder] = useState<Order | null>((loc.state as Order) ?? null)
  useEffect(() => { if (!order) api.order(id).then(setOrder).catch(() => setOrder(null)) }, [id, order])
  if (!order) return <div className="container confirm"><div className="skel line" style={{ height: 40 }} /></div>
  const eta = new Date(order.delivery_eta).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })
  return (
    <div className="container confirm" data-testid="confirmation">
      <div className="check">✓</div>
      <h1>Thanks, {order.address.first_name}.</h1>
      <div className="num" data-testid="order-number">Order {order.number}</div>
      <div className="eta">Arriving by {eta} · Confirmation sent to {order.email}</div>
      <div className="items">
        {order.items.map(it => <div className="mini" key={it.line_id}><img src={it.image} alt="" /><div><div>{it.name}</div><div className="var">{it.color} · {it.size} · ×{it.qty}</div></div><div className="amt">{money(it.price_cents * it.qty)}</div></div>)}
        <div className="row" style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0 0', fontWeight: 600 }}><span>Total charged to card ····{order.card_last4}</span><span>{money(order.total_cents)}</span></div>
      </div>
      <Link to="/" className="btn" style={{ marginTop: 32 }}>Continue shopping</Link>
    </div>
  )
}
